import React from 'react';
import { Box, Typography, Button, LinearProgress, Avatar, Grid, CircularProgress, Divider, Select, MenuItem, FormControl, TextField } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { Center } from '@chakra-ui/react';

const CreditAadhaarBar = ({ total, available, used, left, setAddCreditOpen, tabIndex, setTabIndex, showSelection }) => {
  const availablePercent = (available / total) * 100;
  const usedPercent = (used / total) * 100;
//   const leftPercent = (left / total) * 100;

  return (
    <Box border="1px solid #F1F1F1" borderRadius="12px" minHeight={183}>
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: "19px", p: "20px 30px 3px 30px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignContent: "center", }}>
            <Box sx={{ display: "flex", gap: "15px", }}>
                <img src={`${process.env.PUBLIC_URL}/images/credit.png`} alt="Credit" style={{ width: 45, height: 45 }} />
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Typography sx={{ fontWeight: 400, fontSize: "16px", color: "#626262", lineHeight: "20px" }}>
                        {tabIndex===0 ? 'Total Aadhaar eSign Credits' : 'Total Digital Sign Credits'}</Typography>
                    <Typography sx={{ fontWeight: 600, fontSize: "22px", color: "#1D1D1D", lineHeight: "20px", mt: "16px", display: "flex", justifyContent: "center", alignItems: "center", gap: "12px"}}>{total.toLocaleString()}
                    </Typography>
                </Box>
            </Box>
        </Box>
        <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
            {showSelection && (
                <TextField select variant="outlined" value={tabIndex} onChange={(e) => setTabIndex(e.target.value)} SelectProps={{ native: true }}
                    sx={{
                        boxSizing: "border-box",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        borderColor: "#C0C0C0",
                        borderWidth: "5px",
                        "& .MuiOutlinedInput-root": {
                            borderColor: "#C0C0C0",
                            backgroundColor: "none",
                            "&:hover fieldset": {
                                borderColor: "#C0C0C0",
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#C0C0C0",
                            },
                        },
                        "& .MuiFormHelperText-root": {
                            color: "#FF6666",
                        },
                    }}
                    InputProps={{
                        sx: {
                            width: "192px",
                            borderRadius: "10px",
                            height: 38,
                            fontSize: "14px",
                            fontWeight: "500",
                            "& input::-ms-reveal, & input::-ms-clear": {
                                display: "none",
                            },
                        },
                    }}
                >
                    <option value="0">Aadhaar eSign</option>
                    <option value="1">Digital Sign</option>
                </TextField>
            )}

            <Button variant="contained" sx={{ minWidth: '135px', height: 38, color: "#ffffff", background: "#00B564", textTransform: "none", fontSize: "14px", borderRadius: "10px", border: "1px solid #00B564", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, }} onClick={() => setAddCreditOpen(true)}>+ Add Credits</Button>
        </Box>
      </Box>

      <Box height={10} borderRadius={5} bgcolor="#f0f0f0" overflow="hidden" position="relative" margin="17px 30px">
        <Box sx={{ width: `${availablePercent}%`, background: '#00B564', borderRadius: "320px", position: "absolute", left: 0, height: '100%', zIndex: "999" }} />
        <Box sx={{ width: `${availablePercent}%`, background: '#FFFFFF', borderRadius: "320px", position: "absolute", left: "0.8%",height: '100%', zIndex: "99" }} />
        <Box sx={{ width: `${usedPercent}%`, background: '#EF4949', borderRadius: "320px", position: "absolute", left: `${availablePercent}%`, height: '100%', }} />
        {/* <Box sx={{ width: `${usedPercent}%`, background: '#FFFFFF', borderRadius: "320px", position: "absolute", left: `${availablePercent+1}%`,height: '100%', zIndex: "8" }} />
        <Box sx={{ width: `${leftPercent}%`, background: '#FF5252', borderRadius: "320px", position: "absolute", left: `${availablePercent + usedPercent}%`, zIndex: "7" }} /> */}
      </Box>

      <Divider sx={{ borderWidth : "1px", }} />

      <Box display="flex" alignItems="center" justifyContent="space-evenly">
        {[
            { label: 'Available Credits', value: available, color: '#00B564', percent: availablePercent },
            { label: 'Used Credits', value: used, color: '#EF4949', percent: usedPercent },
        ].map((item, index, array) => (
            <React.Fragment key={item.label}>
                    <Box textAlign="center" position="relative" display="flex" alignItems="center" gap="16px" padding="10px 0" minWidth="190px" justifyContent="center">
                        <Box width={48} height={48} display="flex" alignItems="center" justifyContent="center" sx={{ position: 'relative', zIndex: 1 }}>
                            <CircularProgress
                                variant="determinate"
                                value={100}
                                size={48}
                                thickness={4}
                                sx={{ color: '#f0f0f0', position: 'absolute', top: 0, left: 0 }}
                            />
                            <CircularProgress
                                variant="determinate"
                                value={item.percent}
                                size={48}
                                thickness={4}
                                sx={{ color: item.percent > 0 ? item.color : "#f0f0f0", position: 'absolute', top: 0, left: 0 }}
                            />
                            <CurrencyRupeeIcon sx={{ fontSize: 18, fontWeight: "600", color: item.color }} />
                        </Box>
                        <Box sx={{ textAlign: "left" }}>
                            <Typography sx={{ fontSize: "14px", fontWeight: "400", color: "#222B38CC" }}>{item.label}</Typography>
                            <Typography sx={{ fontSize: "18px", fontWeight: "600", color: "#222B38" }}>{item.value.toLocaleString()}</Typography>
                        </Box>
                    </Box>

                {/* Render divider ONLY if not the last item */}
                {index < array.length - 1 && (
                    <Divider flexItem orientation="vertical" sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#EEEEEE", }} />
                )}
            </React.Fragment>
            ))}
        </Box>
    </Box>
  );
};

export default CreditAadhaarBar;
